<template>
  <el-scrollbar
    class="params-detail-box"
    v-if="paramsData.length">
    <el-collapse
      :value="expandCollapseItems"
      class="el-collapse-primary">
      <el-collapse-item
        :name="index"
        v-for="(item, index) in paramsData"
        :key="index">
        <template slot="title">
          <i class="el-icon-caret-right" />
          <span class="group-name-box">
            {{ item.paramGroup }}
          </span>
        </template>
        <div
          class="params-content-box"
          v-for="(val, i) in item.paramDatas"
          :key="i"
          :title="val.paramValue">
          <div class="name-box">{{ val.paramName }}</div>
          <div class="value-box">
            {{ ` ${val.paramValue}${val.paramType}` }}
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </el-scrollbar>
  <bj-empty
    v-else
    class="empty-page">
    <template class="empty-text">
      <div v-if="isElemExist">
        <span class="empty-text">
          当前选中场景对象，没有{{ elemInfo.isRvtGroupMode ? 'Group' : '' }}属性信息
        </span>
      </div>
      <div v-else>
        <!-- prettier-ignore -->
        <span class="empty-text">
          请选择一个场景对象，以查看对应{{ elemInfo.isRvtGroupMode ? 'Group' : '' }}属性信息
        </span>
      </div>
    </template>
  </bj-empty>
</template>

<script>
export default {
  data() {
    return {
      expandCollapseItems: []
    }
  },
  props: {
    elemInfo: Object,
    paramsData: Array
  },
  watch: {
    paramsData(newVal) {
      if (newVal.length) {
        this.expandCollapseItems = []
        newVal.forEach((item, index) => {
          this.expandCollapseItems.push(index)
        })
      }
    }
  },
  computed: {
    isElemExist() {
      return Object.keys(this.elemInfo).length ? true : false
    }
  },
  mounted() {
    this.expandCollapseItems = []
    this.paramsData.forEach((item, index) => {
      this.expandCollapseItems.push(index)
    })
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.params-detail-box {
  // margin: 0px 16px;
  height: calc(100% - 47px);

  // :deep(.el-collapse) {
  //   .el-collapse-item:last-child {
  //     .params-content-box:last-child {
  //       border-bottom: 1px solid var(--base-border-dark-color14);
  //     }
  //   }
  // }

  .params-content-box {
    display: grid;
    grid-template-columns: 1fr 2fr;
    text-align: left;
    background: transparent;
    border: 1px solid var(--collapse-border-color);
    border-bottom: none;
    word-break: break-all;

    .name-box {
      padding: 4px 4px 4px 24px;
      color: var(--collapse-text-label-color);
      border-right: 1px solid var(--collapse-border-color);
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    .value-box {
      padding: 4px 4px 4px 8px;
      color: var(--collapse-text-value-color);
      word-break: break-all;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
  }
}

.el-collapse-primary {
  border-bottom: 1px solid var(--collapse-border-color);

  .group-name-box {
    margin-left: 2px;
    word-break: break-all;
    white-space: normal;
  }

  :deep(.el-collapse-item__header) {
    height: auto;
    line-height: normal;
    align-items: flex-start;
    text-align: left;

    .el-icon-caret-right {
      margin-top: 4px;
    }
  }
}
</style>
